import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SendingProgressUpdateService {
  private progressUpdates = new Subject<number>();


  // Emit message sending progress for progress bar.
  emitProgressUpdate(progress: number) {
    this.progressUpdates.next(progress);
  }

  // Get message sending progress for progress bar.
  getProgressUpdates() {
    return this.progressUpdates.asObservable();
  }
}
